import Vue from 'vue'
import ViewUI from 'view-design'
import App from './App.vue'
import router from './router'
import store from './store'
import ls from 'store2'
import xss from '@/util/xss'
import api from "@/api";

import htmlToPdf from '@/util/htmlToPdf.js'


import 'view-design/dist/styles/iview.css'
import './theme/index.less'

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import debounce from '@/util/debounce'
import throttle from '@/util/throttle'
import c from '@/util/comfunction'
import moment from 'moment'
import Pop from '@/components/toMaxImg'

Vue.prototype.$api = api
Vue.prototype.$moment = moment //时间处理
Vue.prototype.$debounce = debounce //防抖
Vue.prototype.$throttle = throttle //节流
Vue.prototype.$c = c //封装的常用函数

Vue.prototype.xss = xss
Vue.prototype.$xss = xss

Vue.use(ViewUI)
Vue.use(VueQuillEditor)
Vue.use(Pop)
Vue.use(htmlToPdf)

const app = new Vue({
    router,
    store,
    render: h => h(App)
})

// Vue.$Message.config({

//     duration:4
// });


router.beforeEach((to, from, next) => {
    document.oncontextmenu = function (event) {
        event.returnValue = true;
    };
    if (to.name == "home" && (from.path.indexOf('login') > -1)) {

        let query = ls.get("paraquery")
        if (query) {
            const { path, params } = query
            router.push(`${path}?id=${params.id}&text=${params.text}`)
            next()
        } else {
            next()
        }
    } else {
        store.dispatch("pub/SET_URL", {
            to: to.name,
            form: from.name
        })

        const title = to.meta.title
        let titlearr = []
        if (!titlearr.includes(title)) {
            store.dispatch("pub/SET_TITLE", to.meta.title)
        }

        next()
    }

});



router.afterEach((to, from, next) => {

    window.scrollTo(0, 0);
    const allContent = document.getElementById('allContent')
    Vue.nextTick().then(() => {
        setTimeout(() => {
            if (allContent) allContent.scrollTop = 0
        }, 100);
    })
});

Vue.directive('nohasPermi', {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function (el,binding) {
      let value=binding.value
      let userRole=ls.get("userRole")
      let bo=value.includes(userRole)

     el.style.display=bo?"none":""
    

    }
})

app.$mount('#app')